import { render, staticRenderFns } from "./perfectInformation.vue?vue&type=template&id=168117b2&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./perfectInformation.vue?vue&type=script&lang=js&"
export * from "./perfectInformation.vue?vue&type=script&lang=js&"
import style0 from "./perfectInformation.vue?vue&type=style&index=0&id=168117b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168117b2",
  null
  
)

component.options.__file = "perfectInformation.vue"
export default component.exports